import {call, put, takeEvery} from "redux-saga/effects"

import {
    deleteCrmSystem as deleteCrmSystemApi,
    getCrmSystem as getCrmSystemApi,
    getCrmSystems as getCrmSystemsApi,
    postCrmSystem as postCrmSystemApi,
    updateCrmSystem as updateCrmSystemApi,
} from "../../helpers/backend_helper";
import {CrmSystemTypes} from "./actionsTypes";
import {
    addCrmSystemFail,
    addCrmSystemSuccess,
    deleteCrmSystemFail,
    deleteCrmSystemSuccess,
    getCrmSystemFail,
    getCrmSystemsFail,
    getCrmSystemsSuccess,
    getCrmSystemSuccess,
    modalCrmSystem, updateCrmSystemFail, updateCrmSystemSuccess
} from "./actions";

function* fetchCrmSystemSaga({id}: any) {
    try {
        const response: Promise<any> = yield call(getCrmSystemApi, id);

        yield put(getCrmSystemSuccess(response))
        yield put(modalCrmSystem(true))
    } catch (error) {
        yield put(getCrmSystemFail(error));
    }
}

function* fetchCrmSystemsSaga({next_page, filter}: any) {
    try {
        const response: Promise<any> = yield call(getCrmSystemsApi, next_page, filter);

        yield put(getCrmSystemsSuccess(response))
    } catch (error) {
        yield put(getCrmSystemsFail(error));
    }
}

function* addCrmSystemSaga({data}: any) {
    try {
        const response: Promise<any> = yield call(postCrmSystemApi, data);

        yield put(addCrmSystemSuccess(response));
        yield put(modalCrmSystem(false))
    } catch (error) {
        yield put(addCrmSystemFail(error));
    }
}

function* updateCrmSystemSaga({data, id}: any) {
    try {
        const response: Promise<any> = yield call(updateCrmSystemApi, data, id);

        yield put(updateCrmSystemSuccess(response));
        yield put(modalCrmSystem(false))
    } catch (error) {
        yield put(updateCrmSystemFail(error));
    }
}

function* deleteCrmSystemSaga({id}: any) {
    try {
        yield call(deleteCrmSystemApi, id);
        yield put(deleteCrmSystemSuccess(id));
    } catch (error) {
        yield put(deleteCrmSystemFail(error));
    }
}

function* crmSystemsSaga() {
    yield takeEvery(CrmSystemTypes.GET_CRM_SYSTEM, fetchCrmSystemSaga)
    yield takeEvery(CrmSystemTypes.GET_CRM_SYSTEMS, fetchCrmSystemsSaga)
    yield takeEvery(CrmSystemTypes.ADD_CRM_SYSTEM, addCrmSystemSaga)
    yield takeEvery(CrmSystemTypes.UPDATE_CRM_SYSTEM, updateCrmSystemSaga)
    yield takeEvery(CrmSystemTypes.DELETE_CRM_SYSTEM, deleteCrmSystemSaga)
}

export default crmSystemsSaga;